import {
  IconButton,
  makeStyles,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  withStyles,
} from "@material-ui/core";
import { TextBox } from "devextreme-react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import {
  associateContract,
  changeCustomerVehicle,
  createSimpleContract,
  getContract,
  getContractSimple,
  getContractSimpleSearch,
} from "../../redux/contract/thunks";
import { resetContract } from "../../redux/contract/contractSlice";
import { markCaseWithoutPlate } from "../../redux/cases/thunks";
import { selectContract } from "../../redux/contract/selectors";
import { selectCurrentCase } from "../../redux/currentCase/selectors";
import { Button as TextBoxButton } from "devextreme-react/text-box";
import searchIcon from "../../images/ui-ic-search.svg";
import saveIcon from "../../images/save.svg";
import editIcon from "../../images/edit.svg";
import customersIcon from "../../images/customer.svg";
import { openModal } from "../../redux/modal/modalSlice";
import { faVuejs } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import NewContractDialog from "./NewContractDialog";
import { QUERY_POST_CREATECUSTOMER } from "../../fetch/constantQueries";
import { errorHandler } from "../../commonFunctions/errorHandler";
import iconoAdd from "../../images/iconoAdd.svg";
import { resetCase } from "../../redux/cases/casesSlice";
import { resetCurrentCase } from "../../redux/currentCase/currentCaseSlice";
import { Close } from "@material-ui/icons";

function customStepIcon(stepValue, npsValue) {
  let color = "#EFF1F2";

  if (npsValue) {
    if (stepValue < 0) {
      color = stepValue < npsValue ? "#EFF1F2" : "#D50005";
    }

    if (stepValue > 0) {
      color =
        stepValue > npsValue
          ? "#EFF1F2"
          : npsValue <= 50
            ? "#D50005"
            : "#007BC0";
    }

    if (stepValue == 0) {
      color = npsValue <= 50 ? "#D50005" : "#007BC0";
    }
  }

  return (
    <div
      style={{
        width: "1rem",
        height: "1rem",
        borderRadius: "0.5rem",
        backgroundColor: color,
      }}
    ></div>
  );
}

const CustomConnector = withStyles({
  alternativeLabel: {
    top: "0.5rem",
    left: "calc(-50% + 0.50rem)",
    right: "calc(50% + 0.50rem)",
  },
  line: {
    height: "0.15rem",
    border: 0,
    blockSize: "border-box",
    backgroundColor: "#71767C",
  },
})(StepConnector);

const useStyles = makeStyles({
  stepper: {
    padding: "1rem 0",
  },
  step: {
    padding: 0,
  },
  alternativeLabel: {
    marginTop: "0.25rem !important",
  },
});

function ContractSearch(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const contract = useSelector(selectContract);
  const [searchField, setSearchField] = useState("");
  const currentCase = useSelector(selectCurrentCase);
  const initialSearch = useRef(true);
  const dispatch = useDispatch();
  const location = useLocation();

  async function handleSearch(e) {
    if (searchField === "") {
      dispatch(openModal({ type: "info", message: "Insira uma busca válida" }));
      return;
    }
    const searchParams = { query: "?plate=" + searchField };
    if (
      (!contract.plate || contract.unassigned) &&
      contract.case?.closeDate === null &&
      !contract.case?.state.toLowerCase().includes("gestionado")
    ) {
      dispatch(getContractSimple(searchParams));
    } else {
      dispatch(getContract(searchParams));
      // dispatch(getContractSimpleSearch(searchParams)).then((data) => {
      //   if (data.meta?.requestStatus == "rejected") {
      //     onChangeNewContractData("plate", searchField);
      //     openNewContractDialog("confirm");
      //   }
      // });
    }
  }

  // useEffect(() => {
  //   if (location?.state?.plate) {
  //     setSearchField(location.state.plate);
  //   }
  // }, []);

  useEffect(() => {
    if (
      location?.state?.plate &&
      initialSearch.current &&
      searchField == location.state.plate
    ) {
      initialSearch.current = false;
      delete location.state.plate;
      handleSearch();
    }
  }, [searchField]);

  async function handleAssign() {
    dispatch(
      associateContract({
        body: { plate: contract.plate, caseId: contract.case.caseId },
      }),
    );
  }

  async function handleNoPlate() {
    dispatch(
      markCaseWithoutPlate({ query: `?caseId=${contract.case?.caseId}` }),
    );
  }

  const steps = [-100, -75, -50, -25, "0", 25, 50, 75, 100];

  function hasExpired() {
    const now = dayjs();
    const contractEndDate = dayjs(contract.contractEndDate, "DD/MM/YYYY");
    const difference1 = now.diff(contractEndDate);
    if (difference1 > 0) {
      return true;
    } else return false;
  }

  function handleResetContract() {
    setSearchField("");
    dispatch(resetContract());
    dispatch(resetCase());
    dispatch(resetCurrentCase());
  }

  function openNewContractDialog(dialogOperation) {
    setNewContractDialogOperation(dialogOperation ?? "add");
    setShowNewContractDialog(true);
  }
  function closeNewContractDialog() {
    setNewContractDataForm({});
    setShowNewContractDialog(false);
    setNewContractDialogOperation("confirm");
  }
  function handleNewContractSubmit() {
    try {
      if (newContractDialogOperation == "changeCustomer") {
        if (newContractDataForm.customerId == null) {
          dispatch(
            openModal({
              type: "warning",
              message: "O campo cliente é obrigatório!",
            }),
          );
        } else {
          dispatch(changeCustomerVehicle({ body: newContractDataForm })).then(
            (data) => {
              dispatch(getContract({ query: "?plate=" + searchField })).then(
                (data) => {
                  closeNewContractDialog();
                },
              );
            },
          );
        }
      } else {
        if (
          newContractDataForm.customerId == null ||
          newContractDataForm.brandId == null ||
          newContractDataForm.modelId == null ||
          newContractDataForm.year == null ||
          newContractDataForm.plate == null ||
          newContractDataForm.color == null ||
          newContractDataForm.chassis == null
        ) {
          dispatch(
            openModal({
              type: "warning",
              message: "Todos os campos são obrigatórios!",
            }),
          );
        } else {
          dispatch(createSimpleContract({ body: newContractDataForm })).then(
            (data) => {
              dispatch(getContract({ query: "?plate=" + searchField })).then(
                (data) => {
                  closeNewContractDialog();
                },
              );
            },
          );
        }
      }
    } catch (err) {
      dispatch(openModal(errorHandler(err)));
    }
  }
  function onChangeNewContractData(main, value) {
    if (value == null || value == undefined) return;
    setNewContractDataForm((prevState) => ({ ...prevState, [main]: value }));
  }
  function onChangeNewContractOperation(currentOperation) {
    if (currentOperation == "confirm") {
      setNewContractDialogOperation("add");
    }
    if (currentOperation == "add") {
      setNewContractDialogOperation("confirm");
    }
  }
  function onChangeCustomer() {
    onChangeNewContractData("plate", contract.plate);
    onChangeNewContractData("contractId", contract.id);
    openNewContractDialog("changeCustomer");
  }

  const [newContractDataForm, setNewContractDataForm] = useState({});
  const [showNewContractDialog, setShowNewContractDialog] = useState(false);
  const [newContractDialogOperation, setNewContractDialogOperation] =
    useState("confirm");

  return (
    <>
      <NewContractDialog
        editMode={false}
        title={
          newContractDialogOperation == "changeCustomer"
            ? "Alterar Cliente"
            : "Cadastrar Veículo"
        }
        operation={newContractDialogOperation}
        dialogSize={{ height: "100%" }}
        open={showNewContractDialog}
        onClose={closeNewContractDialog}
        handleOnClick={handleNewContractSubmit}
        dataForm={newContractDataForm}
        onChange={onChangeNewContractData}
        onOperationChange={onChangeNewContractOperation}
      ></NewContractDialog>

      <div className="panel-plate-search-cell">
        <div className="panel-plate-info">
          <div
            style={{
              display: "grid",
              alignItems: "center",
              columnGap: "0.25rem",
              gridTemplateColumns: "max-content min-content min-content",
            }}
          >
            {contract?.chassisNumber == null && (
              <IconButton onClick={() => openNewContractDialog("add")}>
                <img
                  src={iconoAdd}
                  alt="Cadastrar veículo"
                  title="Cadastrar veículo"
                />
              </IconButton>
            )}

            <div style={{ display: "flex", flexFlow: "column" }}>
              {contract?.customerName && (
                <>
                  <div
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "20rem",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: 700,
                        marginRight: "0.5rem",
                      }}
                    >
                      {`${t("Customer")}:`}
                    </span>
                    <span>{contract?.customerName}</span>
                  </div>
                </>
              )}

              <div>
                <span
                  style={{
                    fontSize: "1rem",
                    fontWeight: 700,
                    marginRight: "0.5rem",
                  }}
                >
                  {`${t("Vehicle")}:`}
                </span>
                {contract?.plate && (
                  <span style={{ color: hasExpired() ? "#E20015" : "#000" }}>
                    {contract?.plate}
                  </span>
                )}
              </div>
            </div>
            {contract?.plate && (
              <div alt="Alterar cliente" title={"Alterar cliente"}>
                <IconButton onClick={onChangeCustomer}>
                  <img src={customersIcon} width={20} />
                  <img src={editIcon} width={20} />
                </IconButton>
              </div>
            )}

            {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "0.25rem",
                }}
              >

                {contract?.unassigned && contract.case.closeDate === null && (
                  <span>
                    <IconButton onClick={handleAssign}>
                      <img
                        src={saveIcon}
                        alt="salvar"
                        title={"Asignar matrícula"}
                        width={20}
                      />
                    </IconButton>
                  </span>
                )}
                {(contract.plate == null || contract?.unassigned) &&
                  contract?.case &&
                  !contract.case.withoutPlate &&
                  contract?.case.state !== "Cerrado" &&
                  !contract?.case.state.toLowerCase().includes("gestionado") &&
                  !currentCase.withoutPlate && (
                    <span>
                      <IconButton onClick={handleNoPlate}>
                        <i
                          className="icon icon-alert-success"
                          alt={"sin matrícula"}
                          title="Marcar caso sin matrícula"
                        ></i>
                      </IconButton>
                    </span>
                  )}
              </div>
              {(contract.plate == null || contract?.unassigned) &&
                contract?.case &&
                contract.case.withoutPlate &&
                (contract?.case.state !== "Cerrado" ||
                  !contract?.case.state.toLowerCase().includes("gestionado")) &&
                currentCase.withoutPlate && (
                  <span>
                    <i
                      style={{ fontSize: "1.5rem", color: "#78BE20" }}
                      className="icon icon-alert-success"
                      alt={"sin matrícula"}
                      title="Marcado sin matrícula"
                    ></i>
                  </span>
                )}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "0.25rem",
                }}
              >
                {contract &&
                  contract.exceptions &&
                  contract.exceptions.length > 0 && (
                    <div style={{ color: "#ffcf00", fontSize: "1.5rem" }}>
                      {" "}
                      <i
                        className="icon icon-alert-warning"
                        title="El cliente tiene Exceções"
                      />
                    </div>
                  )}
                {contract && contract.uciCustomer && <div> <i style={{color:"#E20015", fontSize: "1.25rem"}} className="icon icon-uci-client" title="Cliente en UCI" /></div>}
                {contract && contract.vip && (
                <div>
                  {" "}
                  <FontAwesomeIcon
                    icon={faVuejs}
                    color="#B9C40E"
                    transform={{ size: 30 }}
                    title="VIP"
                  />
                </div>
              )}
              {contract && contract.highLevel && (
                <div style={{ color: "#78BE20", fontSize: "1.5rem" }}>
                  {" "}
                  <i className="icon icon-dollar" title="High Level" />
                </div>
              )}
              {contract && contract.alphacity && (
                <div>
                  {" "}
                  <i
                    style={{ color: "#E20015", fontSize: "1.75rem" }}
                    className="icon icon-alphacity"
                    title="Alphacity"
                  />
                </div>
              )}
              {contract && contract.vipVehicle && (
                <div style={{ color: "#ffcf00", fontSize: "1.5rem" }}>
                  {" "}
                  <i className="icon icon-car" title="Premium" />
                </div>
              )}
              </div> */}
          </div>

          {contract?.id == null ? (
            <TextBox
              label={t("Search")}
              labelMode="floating"
              value={searchField}
              mode="text"
              onValueChange={(value) => setSearchField(value)}
              onEnterKey={() => handleSearch()}
              valueChangeEvent="keyup"
            >
              <TextBoxButton
                name="search"
                location="after"
                options={{
                  icon: searchIcon,
                  stylingMode: "text",
                  onClick: () => handleSearch(),
                }}
              />
            </TextBox>
          ) : (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <IconButton
                onClick={handleResetContract}
                alt="Fechar cliente"
                title="Fechar cliente"
              >
                <Close />
              </IconButton>
            </div>
          )}
        </div>
        {/* <div className="panel-nps-info">
                        <span style={{fontSize: "1rem", fontWeight: 700}}>QMAI Score:</span>                 
                        <span>  
                            <Stepper classes={{root: classes.stepper}} connector={<CustomConnector backgroundColor={"backgroundColor"}/>} alternativeLabel activeStep={null}>
                              {steps.map(step=>
                                <Step classes={{horizontal: classes.step}}>
                                  <StepLabel classes={{label: classes.alternativeLabel}} StepIconComponent={()=>customStepIcon(step, contract.nps)}>{step}</StepLabel>
                                </Step>
                              )}
                            </Stepper>
                        </span>
                    </div> */}
      </div>
    </>
  );
}

export { ContractSearch };
